import { render, staticRenderFns } from "./SettingsTabPromotions.vue?vue&type=template&id=3b893880&scoped=true"
import script from "./SettingsTabPromotions.vue?vue&type=script&lang=ts"
export * from "./SettingsTabPromotions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b893880",
  null
  
)

export default component.exports